import { gql } from '@apollo/client';
import client from 'apollo/apollo-client';

export async function WaterPumpState(variables) {
  return await new Promise((resolve, reject) => {
    client
      .mutate({
        mutation: STATE_WATER_PUMPS,
        variables,
        skip: skip(variables),
        refetchQueries: ['WaterPumpsByCustomer', 'WaterPumpsById'],
        fetchPolicy: 'network-only',
      })
      .then(
        ({
          data: {
            WaterPumpsState: { error, data, message },
          },
          loading,
        }) => {
          resolve({ data, loading, error, message });
        },
      )
      .catch((error) => {
        reject(new Error({ error: true, message: error.message, data: {} }));
      });
  });
}

function skip(variables) {
  let skip = true;
  let { _id } = variables;
  skip = ![_id].every((v) => v);
  return skip;
}

const STATE_WATER_PUMPS = gql`
  mutation WaterPumpsState($_id: ID!) {
    WaterPumpsState(_id: $_id) {
      error
      data {
        _id
        code
        url
        customerId
        active
        power_status
      }
      message
    }
  }
`;
